<template>
    <div  class="all-height">
        <el-main class="all-height" v-if="flag">
            <div class="operation-bar">
                <h1>报价管理</h1>
                <div class="operation-bar-right">

                    <el-select size="mini" v-model="keywords.status" placeholder="请选择状态" >
                        <el-option
                            v-for="item in statusOpts"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>

                    <el-select style="margin-left: 20px" size="mini" v-model="keywords.mtrlCategory" placeholder="请选择物资分类" >
                        <el-option
                            v-for="item in mtrlCateOpts"
                            :key="item.value"
                            :label="item.label"
                            :value="item.value">
                        </el-option>
                    </el-select>
                    <div class="input-box">
                        <i></i>
                        <input type="text" v-model="keywords.offerCode" placeholder="请输入报价单据号"/>
                    </div>
                    <div class="input-box">
                        <i></i>
                        <input type="text" v-model="keywords.ownerCompany" placeholder="请输入需方公司"/>
                    </div>
                    <div class="input-box">
                        <i class="el-icon-search" @click="query(1)"></i>
                        <input type="text" v-model="keywords.inquiryCode" placeholder="请输入询价单号"/>
                    </div>
                </div>
            </div>

            <div class="table-box">
                <el-table :data="offerInfoList"
                          height="calc(100% - 55px)"
                          :header-cell-style="{background:'#4885CA',color: 'white'}"
                          @row-dblclick = "rowDblclick"
                >
                    <el-table-column width="100px" prop="offerCode" label="报价单据号" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="100px"  prop="offerDate" label="单据日期" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column width="80px"  label="状态" header-align="center" align="center">
                        <template slot-scope="scope">
                            <el-tag  type="primary" v-if="scope.row.status === 0">暂存</el-tag>
                            <el-tag  type="success" v-else>提交</el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column width="100px"  prop="mtrlCategory" label="物资类别" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column width="250px"  prop="ownerCompany" label="需方公司" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="100px"  prop="inquiryCode" label="询价单号" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="250px"  prop="vendor" label="报价方" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="100px"  prop="quoterDate" label="报价日期" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column width="120px"  prop="payMethod" label="付款方式" header-align="center" align="center" :show-overflow-tooltip="true">
                    </el-table-column>
                    <el-table-column width="80px"  prop="validDuration" label="有效期" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column width="80px"  prop="deliveryDuration" label="交货期" header-align="center" align="center">
                    </el-table-column>
                    <el-table-column prop="remark" label="备注" header-align="center" align="center">
                    </el-table-column>
                </el-table>
                <div class="table-page">
                    <el-pagination
                        @size-change="changePageSize"
                        @current-change="changeCurrentPage"
                        :current-page="page.current"
                        :page-sizes="page.pageSizes"
                        :page-size="page.pageSize"
                        layout="total, sizes, prev, pager, next, jumper"
                        :total="page.total">
                    </el-pagination>
                </div>
            </div>
        </el-main>

        <bill-offer-detail :is-lock="isLock" @closeDetail="closeDetail" :offerInfo = "offerInfo" v-else></bill-offer-detail>

    </div>

</template>

<script>
import {mapState} from 'vuex';
import billOfferDetail from './bill-offer-detail';
export default {
    name: 'bill-offer',
    components: {
        billOfferDetail
    },
    data() {
        return {
            flag: true,
            isLock: false,
            statusOpts: [
                {value: '', label: '全部状态'},
                {value: 0, label: '暂存'},
                {value: 1, label: '提交'}
            ],
            mtrlCateOpts: [
                {value: '', label: '全部物资分类'},
                {value: '电气', label: '电气'},
                {value: '机械', label: '机械'},
                {value: '外协', label: '外协'},
                {value: '后勤', label: '后勤'},
                {value: '钢材', label: '钢材'},
                {value: '电缆线', label: '电缆线'},
                {value: '华原', label: '华原'},
                {value: '蒲瑞', label: '蒲瑞'},
                {value: '矿机', label: '矿机'},
            ],
            editForm: {
            },
            billOfferId: '',
            fileList: [],
            fileShowList: [],
        };
    },
    computed: {
        ...mapState('bill/billOffer', ['page', 'offerInfoList', 'keywords', 'offerInfo'])
    },
    methods: {
        query(currentPage) {
            if(currentPage){
                this.$store.commit('bill/billOffer/SET_PAGE_CURRENT', currentPage);
            }
            this.$store.dispatch('bill/billOffer/getOfferInfoList');
        },
        modifyFlag() {
            this.flag = !this.flag;
        },
        rowDblclick(row) {
            this.$store.dispatch('bill/billOffer/getBillOfferVo', row.id).then((ret)=>{
                if(ret.code === '200') {
                    this.flag = !this.flag;
                    if(row.status === 0){
                        this.isLock = false;
                    }else{
                        this.isLock = true;
                    }
                }else{
                    this.$message.error(ret.data?ret.data : ret.message);
                }
            })

        },
        closeDetail() {
            this.modifyFlag();
        },

        changePageSize(val) {
            this.$store.commit('bill/billOffer/SET_PAGE_SIZE', val);
            this.query();
        },
        changeCurrentPage(val) {
            this.$store.commit('bill/billOffer/SET_PAGE_CURRENT', val);
            this.query();
        },

        handleRemove(file, fileList) {
            console.log(file);
            console.log(fileList);
        },
        uploadSectionFile(params) {
            this.fileList.push(params.file);
        },
        clearMsgDialog() {
            this.fileShowList = [];
            this.fileList = [];
            this.dialogVisible = false;
        }
    },
    created() {
        this.query();
    }
}

</script>

<style scoped>
.table-box{
    position: relative;
    margin-top: 5px;
    background-color: white;
    height: calc(100% - 35px);
    width: 100%;
}
.table-page {
    width: 100%;
    text-align: center;
    position: absolute;
    bottom: 10px;
}
.el-table .el-button{
    padding: 0;
}
.cell i {
    font-size: 25px;
    cursor: pointer;
}
.cell i:hover {
    color: #5ED1FD;
}
.textArea-box {
    max-height: 300px;
    overflow-y: scroll;
}
/deep/ .el-table tbody tr:hover {cursor: pointer }
</style>
